import React from 'react';

const SubmitBtn = ({ type, className, children, onclick, disabled }) => {
    return (
        <button type={type} className={`text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 ${className}`} onClick={onclick} disabled={disabled}>
            {children}
        </button>
    );
};

export default SubmitBtn;